/**
 * BreadcrumbTracker — Navigációs előzmények rögzítése.
 * React Router useLocation-nel hívandó.
 * Ring buffer, max 20 route.
 */

const MAX_ENTRIES = 20;

class BreadcrumbTrackerService {
  private routes: { path: string; timestamp: number }[] = [];

  /** Új route rögzítése (useLocation effect-ből hívandó) */
  push(pathname: string): void {
    // Duplikátum szűrés (ugyanaz a route egymás után)
    const last = this.routes[this.routes.length - 1];
    if (last && last.path === pathname) return;

    this.routes.push({ path: pathname, timestamp: Date.now() });
    if (this.routes.length > MAX_ENTRIES) {
      this.routes.shift();
    }
  }

  /** Utolsó N route, " → " elválasztóval (ticket csatoláshoz) */
  getTrail(limit = 5): string {
    return this.routes
      .slice(-limit)
      .map(r => r.path)
      .join(' → ');
  }

  /** Utolsó N route objektumként */
  getRecent(limit = 5): { path: string; timestamp: number }[] {
    return this.routes.slice(-limit);
  }

  getCount(): number {
    return this.routes.length;
  }
}

export const breadcrumbTracker = new BreadcrumbTrackerService();
